const updateMediaGrid = (productMedia, productData) => {
  // Loading media grid elements
  const imageElements = document.querySelectorAll(".fusion-pdp__media-item");

  // Wrapper of the entire media grid
  const mediaContainer = document.getElementById("fusionMediaInnerWrapper");

  // Thumbnail elements
  const thumbnailElements = document.querySelectorAll(
    ".fusion-pdp__media-thumbnail",
  );
  const thumbnailContainer = document.querySelector(
    ".fusion-pdp__media-thumbnails-container",
  );

  const desktopMediaElements = document.querySelectorAll(
    ".fusion-pdp__media-item-desktop",
  );
  const desktopMediaContainer = document.querySelector(
    ".fusion-pdp__media-item-desktop-container",
  );

  // Remove thumbnails elements from previous product
  thumbnailElements.forEach((elm) => {
    elm.remove(); // Remove extra thumbnails
  });

  productMedia.forEach((img, i) => {
    // Add or update media elements and containers
    if (imageElements[i] === undefined) {
      // Create a new media item if not enough exist
      mediaContainer.insertAdjacentHTML(
        "beforeend",
        `
          <div id="fusionMediaItem">
              <div class="fusion-pdp__media-item media pdp-media-ratio">
                  <img class="fade-in-simple" loading="lazy" height="1400" width="1050" data-src="${img.src}" src="${img.src}" srcset="${img.srcsetMobile}" sizes="${img.sizesMobile}">
              </div>
          </div>
        `,
      );
    } else {
      // Update existing media item
      imageElements[i].innerHTML = `
        ${
          i === 0 && (productData?.product?.model_info || productData?.model_info)
            ? `
              <p class="fusion-pdp__media-model-size body">${productData?.product?.model_info || productData?.model_info}</p>`
            : ""
        }
        <img class="fade-in-simple" loading="lazy" height="1400" width="1050" data-src="${img.src}" src="${img.src}" srcset="${img.srcsetMobile}" sizes="${img.sizesMobile}">
    `;
    }

    // Create a new set of thumbnails
    thumbnailContainer.insertAdjacentHTML(
      "beforeend",
      `
        <button @click="setActiveSlide(${i})" class="fusion-pdp__media-thumbnail focus-visible:outline-offset-[-2px] hs-carousel-pagination-item fade-in-simple relative shrink-0 rounded-[5px] overflow-y-hidden cursor-pointer border w-[80px] h-[106.5px]" :class="activeSlide === ${i} ? 'border-[#1f1f22]' : 'border-[#e3e3e3]'">
          <img class="fade-in-simple pointer-events-none object-cover object-center h-[106.5px] w-full size-full rounded-[5px]" src="${img.src_thumbnail}" alt="Thumbnail ${i + 1} of ${productData?.product?.title}, ${i + 1} of ${productMedia.length}" srcset="${img.srcsetThumbnail}" sizes="${img.sizesThumbnail}">
        </button>
      `
    );

    if (desktopMediaElements[i] === undefined) {
      // Create a new desktop media item if not enough exist
      desktopMediaContainer.insertAdjacentHTML(
        "beforeend",
        `
          <div x-show="activeSlide === ${i}" class="fusion-pdp__media-item-desktop h-full bg-transparent hs-carousel-slide rounded-[5px]">
          <img class="fade-in-simple pointer-events-none size-full object-contain rounded-lg" src="${img.src}" alt="${productData?.product?.title} Image ${i + 1}" srcset="${img.srcset}" sizes="${img.sizes}">
          </div>
        `
      );
    } else {
      // Update existing desktop media item
      desktopMediaElements[i].innerHTML = `
        ${
          i === 0 && (productData?.product?.model_info || productData?.model_info)
            ? `
              <p class="fusion-pdp__media-model-size body">${productData?.product?.model_info || productData?.model_info}</p>`
            : ""
        }
        <img class="fade-in-simple pointer-events-none rounded-[5px] object-cover h-full" height="1400" width="1050" src="${img.src}" srcset="${img.srcset}" sizes="${img.sizes}">
      `;
    }
  });

  // Remove extra media elements left over from previous products
  imageElements.forEach((elm, i) => {
    if (i >= productMedia.length) {
      if (elm.closest) {
        elm.closest("#fusionMediaItem").remove(); // Remove extra media elements
      }
    }
  });

  desktopMediaElements.forEach((elm, i) => {
    if (i >= productMedia.length) {
      elm.remove(); // Remove extra thumbnails
    }
  });

  if (window.innerWidth <= 900 && window.fusionDataLayer.activeSlider) {
    window.fusionElements.pdpMobileSlider.update();
  }
};

export default updateMediaGrid;
